import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  textInput: {
    margin: theme.spacing(0, 0, 3, 0),
    width: '30ch',
    '& p': {
      position: 'absolute',
      top: '3.5rem',
      width: '100%',
      fontSize: '0.6rem',
      marginLeft: 0,
    },
  },
  adornment: {
    '& p': {
      position: 'unset',
      fontSize: '0.8rem',
    },
  },

}));

export default useStyles;
